export default function Success({
  title = "Amazing!",
  text = "That worked!",
  children,
}) {
  return (
    <div className="flex flex-col items-center content-center justify-center space-y-4">
      <svg
        id="success-icon"
        enableBackground="new 0 0 512 512"
        viewBox="0 0 512 512"
        className="w-32 h-32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <ellipse
              cx="247.513"
              cy="304.86"
              fill="#f6e06e"
              rx="197.084"
              ry="197.084"
              transform="matrix(.707 -.707 .707 .707 -143.074 264.309)"
            />
            <path
              d="m247.293 113.766c-4.354 0-8.671.156-12.955.434 89.403 6.249 159.993 80.745 159.993 171.737 0 95.087-77.084 172.171-172.171 172.171-90.992 0-165.488-70.59-171.737-159.993-.278 4.284-.434 8.601-.434 12.955 0 108.968 88.336 197.304 197.304 197.304s197.304-88.336 197.304-197.304-88.336-197.304-197.304-197.304z"
              fill="#dda86a"
            />
            <path
              d="m381.346 308.591c0 73.914-59.919 133.834-133.834 133.834s-133.834-59.919-133.834-133.834z"
              fill="#d789b9"
            />
            <path
              d="m163.005 338.875c33.068-14.699 209.618-3.668 209.618-3.668 0 7.343 2.704-8.158 2.704-27.424h-269.284c-.478 35.505 33.766 94.548 82.181 122.298 14.678 8.413 50.909 13.154 56.681 12.399-52.519-3.578-114.968-88.906-81.9-103.605z"
              fill="#c668b9"
            />
            <path
              d="m336.634 408.426c-12.777-28.472-47.849-48.92-89.121-48.92s-76.345 20.448-89.121 48.92c0 0 44.957 33.999 89.121 33.999s89.121-33.999 89.121-33.999z"
              fill="#e8c2d8"
            />
            <path
              d="m454.433 68.925 8.348 23.473c.357 1.005 1.065 1.801 1.958 2.204l20.854 9.396c2.946 1.328 2.946 6.022 0 7.349l-20.854 9.396c-.893.402-1.6 1.199-1.958 2.204l-8.348 23.473c-1.179 3.316-5.35 3.316-6.529 0l-8.348-23.473c-.357-1.005-1.065-1.801-1.958-2.204l-20.854-9.396c-2.946-1.327-2.946-6.022 0-7.349l20.854-9.396c.893-.402 1.6-1.199 1.958-2.204l8.348-23.473c1.179-3.316 5.349-3.316 6.529 0z"
              fill="#fbf2aa"
            />
            <path
              d="m142.415 1.845 6.192 17.412c.265.745.79 1.336 1.452 1.635l15.47 6.97c2.186.985 2.186 4.467 0 5.451l-15.47 6.97c-.662.298-1.187.889-1.452 1.635l-6.192 17.412c-.875 2.46-3.969 2.46-4.844 0l-6.192-17.412c-.265-.745-.79-1.336-1.452-1.635l-15.47-6.97c-2.185-.985-2.185-4.467 0-5.451l15.47-6.97c.662-.298 1.187-.889 1.452-1.635l6.192-17.412c.875-2.46 3.969-2.46 4.844 0z"
              fill="#fbf2aa"
            />
            <g fill="#f7e16e">
              <path d="m395.26 38.202c0 6.774-5.491 12.265-12.265 12.265s-12.266-5.492-12.266-12.265c0-6.774 5.491-12.266 12.266-12.266 6.774 0 12.265 5.491 12.265 12.266z" />
              <path d="m60.433 106.525c0 10.006-8.112 18.118-18.118 18.118s-18.118-8.112-18.118-18.118 8.112-18.118 18.118-18.118c10.006.001 18.118 8.112 18.118 18.118z" />
            </g>
          </g>
          <g fill="#3c122c">
            <path d="m247.513 512c-114.218 0-207.14-92.923-207.14-207.14s92.922-207.14 207.14-207.14 207.14 92.923 207.14 207.14c-.001 114.217-92.923 207.14-207.14 207.14zm0-394.168c-103.128 0-187.027 83.9-187.027 187.027s83.9 187.028 187.027 187.028 187.027-83.9 187.027-187.027-83.9-187.028-187.027-187.028z" />
            <path d="m200.923 258.489c-5.553 0-10.056-4.502-10.056-10.056 0-15.434-12.556-27.99-27.989-27.99-15.434 0-27.99 12.556-27.99 27.99 0 5.554-4.503 10.056-10.056 10.056s-10.056-4.502-10.056-10.056c0-26.524 21.579-48.102 48.103-48.102 26.523 0 48.102 21.579 48.102 48.102-.002 5.554-4.505 10.056-10.058 10.056z" />
            <path d="m370.195 258.489c-5.553 0-10.056-4.502-10.056-10.056 0-15.434-12.556-27.99-27.99-27.99-15.433 0-27.989 12.556-27.989 27.99 0 5.554-4.503 10.056-10.056 10.056s-10.056-4.502-10.056-10.056c0-26.524 21.579-48.102 48.102-48.102 26.524 0 48.103 21.579 48.103 48.102-.002 5.554-4.505 10.056-10.058 10.056z" />
            <path d="m381.347 298.535h-267.668c-5.553 0-10.056 4.502-10.056 10.056 0 79.341 64.549 143.89 143.89 143.89s143.89-64.549 143.89-143.89c0-5.553-4.503-10.056-10.056-10.056zm-210.227 107.372c13.725-21.999 43.33-36.345 76.393-36.345 33.062 0 62.667 14.346 76.393 36.345-21.054 16.564-47.588 26.462-76.393 26.462s-55.339-9.898-76.393-26.462zm167.698-13.842c-18.123-25.931-52.979-42.615-91.306-42.615-38.328 0-73.187 16.682-91.308 42.613-18.03-19.706-29.789-45.241-32.066-73.415h246.747c-2.276 28.175-14.035 53.711-32.067 73.417z" />
          </g>
        </g>
      </svg>
      <div className="text-center">
        {children || (
          <>
            <h3 className="text-3xl">{title}</h3>
            <p className="text-2xl">{text}</p>
          </>
        )}
      </div>
    </div>
  );
}
